import { useEffect, useState } from "react";

function uuidGen() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
}

function getOrdinal(number) {
  let ends = ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"];
  if (number % 100 >= 11 && number % 100 <= 13) return "th";
  else return ends[number % 10];
}
function isTouchDevice() {
  if ("ontouchstart" in document.documentElement) {
    return true;
  }
  return false;
}

export const IMAGE_TAGS = [
  "favorite",
  "blue",
  "green",
  "yellow",
  "red",
  "violet",
  "grey",
  "subjectfav",
  "hidden",
  "spare",
];

function getImageTagSrc(tag) {
  return `/design/DEFAULT/graphics/prophoto/tags/${tag}.png`;
}

function getImageSize(fillin, swidth, sheight, dwidth, dheight) {
  let diff = 0;
  let height = 0;
  let width = 0;
  let left = 0;
  let top = 0;

  var dratio = dwidth / dheight;
  var sratio = swidth / sheight;

  if (fillin == "fit-in") {
    if (dratio < sratio) {
      diff = dwidth / swidth;
      width = dwidth;
      height = diff * sheight;
    } else {
      diff = dheight / sheight;
      height = dheight;
      width = diff * swidth;
    }
    left = dwidth / 2 - width / 2;
    top = dheight / 2 - height / 2;
  } else {
    if (dratio > sratio) {
      diff = dwidth / swidth;
      width = dwidth;
      height = diff * sheight;
    } else {
      diff = dheight / sheight;
      height = dheight;
      width = diff * swidth;
    }
    left = dwidth / 2 - width / 2;
    top = dheight / 2 - height / 2;
  }

  return {
    left,
    top,
    width,
    height,
  };
}

function getAllUrlParams(url) {
  // get query string from url (optional) or window
  var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split("#")[0];

    // split our query string into its component parts
    var arr = queryString.split("&");

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split("=");

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof a[1] === "undefined" ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === "string")
        paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/) || paramName.match(/%5b(\d+)?%5d$/)) {
        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]|%5b(\d+)?%5d$/, "");
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === "string") {
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

/**
 * @param {*} inputData - JSON body for request
 */
const callAPI = (path, method = "GET", inputData = null) => {
  const init = {
    method,
    headers: {},
  };

  if (["POST", "PUT", "PATCH"].includes(method) && inputData) {
    init.body = JSON.stringify(inputData);
    init.headers["Content-Type"] = "application/json";
  }

  const processResponse = (response) => {
    const addStatusCode = (data) => {
      console.log("Fetch: Type of data is", typeof data);
      return typeof data === "object" && !Array.isArray(data) && data !== null
        ? { httpStatusCode: response.status, ...data }
        : data;
    };

    if (response.ok) {
      return response.json().then(addStatusCode);
    } else {
      const contentType = response.headers.get("content-type");
      const isJson = contentType && contentType.includes("application/json");
      const errorPromise = isJson ? response.json() : response.text();

      return errorPromise.then((error) => {
        throw addStatusCode(error);
      });
    }
  };

  return fetch(path, init)
    .then(processResponse)
    .catch((err) => {
      console.error("API call failed", path, method, err);
      throw err; // Re-throw the error for further handling if necessary
    });
};

const isWebPSupported = () => {
  return new Promise((resolve, reject) => {
    const elem = document.createElement("canvas");
    if (!!(elem.getContext && elem.getContext("2d"))) {
      // was able or not to get WebP representation
      if (elem.toDataURL("image/webp").indexOf("data:image/webp") == 0) {
        resolve("WebP Supported");
      } else {
        reject("WebP Not supported");
      }
    } else {
      reject("Old browser, webp not supported");
    }
  });
};

/**
 * @param {string} path
 * @param {string} method
 * @param {object} [inputData]
 *
 * @returns {[any, boolean, any]} An array containing:
 *   - {any} data: The response data from the API.
 *   - {boolean} loading: Indicates if the API call is in progress.
 *   - {any} error: The error object if the API call fails, otherwise null.
 *
 * @example
 * const [data, loading, error] = useAPI('/api/users', 'GET');
 */
const useAPI = (path, method = "GET", inputData = null) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  // Will only trigger once
  useEffect(() => {
    setLoading(true);
    callAPI(path, method, inputData)
      .then((json) => {
        setData(json);
      })
      .catch((err) => {
        setError(err);
      })
      .finally((e) => {
        console.log("Request complete");
        setLoading(false);
      });
  }, [path, inputData]);
  return [data, loading, error];
};

const isValidEmailAddress = (emailAddress) => {
  console.log("Checking email address", emailAddress);
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailAddress);
};

function upperCaseFirst(string) {
  const arr = string.split(" ");
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(" ");
}

export {
  uuidGen,
  isTouchDevice,
  getImageSize,
  useAPI,
  callAPI,
  isValidEmailAddress,
  isWebPSupported,
  upperCaseFirst,
  getAllUrlParams,
  getOrdinal,
  getImageTagSrc,
};
